import React from "react";
import { Link } from "react-router-dom";
import { Star, Timer } from "lucide-react";
import { MOCK_QUOTES } from "../../data/mock";

export default function CustomerQuotes() {
  return (
    <div data-testid="customer-quotes">
      <h1 className="font-display text-3xl font-bold">My Quotes</h1>
      <p className="mt-1 text-sm text-neutral-600">Live bids from verified vendors nearby. Pick before the timer runs out.</p>

      {MOCK_QUOTES.map((q) => (
        <div key={q.id} className="mt-4 rounded-lg border border-neutral-200 bg-white p-5" data-testid={`quote-${q.id}`}>
          <div className="flex flex-wrap items-start justify-between gap-3">
            <div>
              <div className="font-mono text-xs text-neutral-500">{q.id}</div>
              <div className="mt-1 font-display text-lg font-bold">{q.spec}</div>
            </div>
            <div className="inline-flex items-center gap-1 rounded-full border border-neutral-900 bg-lime-100 px-3 py-1 text-xs font-mono font-bold"><Timer size={12} /> {q.countdown}</div>
          </div>

          <div className="mt-3 space-y-2">
            {q.vendors.map((v) => (
              <div key={v.name} className="flex flex-col justify-between gap-2 rounded-md border border-neutral-200 p-3 md:flex-row md:items-center" data-testid={`quote-vendor-${v.name.replace(/\s+/g, "-").toLowerCase()}`}>
                <div>
                  <div className="flex items-center gap-2 font-semibold">{v.name} <span className="rounded-full bg-lime-400 px-2 py-0.5 text-[10px] font-bold text-neutral-950">{v.badge}</span></div>
                  <div className="mt-1 flex items-center gap-3 text-xs text-neutral-500">
                    <span className="flex items-center gap-1 text-lime-600"><Star size={12} fill="currentColor" strokeWidth={0} /> {v.rating}</span>
                    <span>{v.distance}</span>
                    <span>Ready {v.ready}</span>
                  </div>
                </div>
                <div className="flex items-center gap-3">
                  <div className="font-mono text-xl font-bold">₹{v.price.toLocaleString("en-IN")}</div>
                  <Link to="/customer/new-order" className="rounded-md bg-neutral-950 px-3 py-2 text-xs font-bold text-white hover:bg-neutral-800">Select</Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
